import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button,
    CircularProgress, Alert, Box,
} from '@mui/material';
import { toast } from 'react-toastify';
import invoicingService from '../../services/invoicing';

const VoidDialog = ({ open, invoiceId, onClose, onSuccess }) => {
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async () => {
        if (!reason || reason.trim() === '') {
            setError('Please provide a reason for voiding the invoice');
            return;
        }

        try {
            setLoading(true);
            setError(null);

            await invoicingService.voidInvoice(invoiceId, reason);

            toast.success('Invoice voided successfully. Credit note generated.');
            setReason('');
            await onSuccess();
        } catch (err) {
            const msg = err.response?.data?.detail || 'Failed to void invoice';
            setError(msg);
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setReason('');
        setError(null);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Void Invoice</DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        label="Reason for Voiding (Required)"
                        multiline
                        rows={4}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="e.g., Incorrect invoice, Customer request, etc."
                        fullWidth
                        disabled={loading}
                        variant="outlined"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>Cancel</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="error"
                    disabled={loading || !reason.trim()}
                >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Void Invoice'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default VoidDialog;
